import { takeLatest, call, put, StrictEffect, cancel, delay, takeEvery, select } from 'redux-saga/effects';
import {
    fetchSiteMap,
    fetchSiteMapSuccess,
    fetchSiteMapError,
    createSiteMap,
    createSiteMapSuccess,
    createSiteMapError,
    deleteSiteMap,
    deleteSiteMapSuccess,
    deleteSiteMapError,
    updateSiteMap,
    updateSiteMapSuccess,
    updateSiteMapError,
    reorderSiteMap,
    reorderSiteMapSuccess,
    reorderSiteMapError,
    sitemapUrlsAdd,
    sitemapUrlsAddSuccess,
    sitemapUrlsAddError,
    fetchSiteMapCreating,
    fetchSiteMapEndCreating,
    updateSiteMapFromUrl,
    updateSiteMapFromUrlSuccess,
    updateSiteMapFromUrlError,
    DeleteAllSitemap,
    DeleteAllSitemapSuccess,
    DeleteAllSitemapError
} from './index';
import { PayloadAction } from '@reduxjs/toolkit';
import { apiInstance } from 'src/services/interceptor';
import { SagaIterator } from 'redux-saga';
import { Exception } from 'sass';


interface PayloadProps {
    tenantId: string;
    siteId: string;
    pageUrl?: string;
    oldPageUrl?: string; 
    newPageUrl?: string;
    isNewVersion?: boolean, 
    urls?:any;
    pageId?: string;
    currentRecordId?: string;
    targetRecordId?: string;
    versionNumber?:any;
    siteUUID?: string;
    sitemapURL?: string;
    company_id?:string;
    
}

function* fetchSiteMapSaga({ payload: { siteUUID } }: PayloadAction<PayloadProps>): SagaIterator {

    try {
        if ( !siteUUID ) return;
        while (true) {
        const check_existance = yield call(apiInstance.post, `reporttool/ialengine/checksitemapexistance` , { siteUUID }); 

        if(check_existance?.data?.statusCode == 200){
            const response = yield call(apiInstance.post,  'reporttool/usermanagement/sitemap/get-sitemap', { siteUUID });
            if(response.status != 200){
                throw new Error("check get sitemap has faild");
            }

            if(response.status == 200){
                const sitemap: any = [];
                sitemap[siteUUID] = response.data?.data;
                yield put(fetchSiteMapSuccess(sitemap)); 
                yield put(fetchSiteMapEndCreating(siteUUID));                 
                yield cancel();
                return;
            }

        }
        if(check_existance?.data?.statusCode == 202){
            yield put(fetchSiteMapCreating(siteUUID)); 
            yield delay(3000);
            continue;
        }

        if(check_existance?.data?.statusCode != 200){
            throw new Error("check checksitemapexistance has faild");
        }
        yield put(fetchSiteMapError('error'));
    }
    } catch (error: any) {
        const errorMessage = error ;
        
        yield put(fetchSiteMapError(errorMessage));
    }
}

function* createSiteMapSaga({ payload: { siteUUID }}: PayloadAction<PayloadProps>): SagaIterator {    
    const response =  yield call(apiInstance.post, `reporttool/ialengine/createsitemap` , { siteUUID });
    if(response.data.statusCode == 200){
        while (true) {
            try {

                    const check_existance = yield call(apiInstance.post, `reporttool/ialengine/checksitemapexistance` , { siteUUID }); 
                    
                    if(check_existance?.data?.statusCode == 202){

                            yield delay(3000);
                            continue;
                    }
                    if(check_existance?.data?.statusCode != 200){
                        throw new Error("check checksitemapexistance has faild");
                    }

                    const check_response = yield call(apiInstance.post, 'reporttool/usermanagement/sitemap/get-sitemap', { siteUUID });  
                                     
                    if (check_response?.status == 200) {

                        if ( !siteUUID ) return
                        const sitemap: any = {};
                        // sitemap[siteUUID] = check_response?.data;
                        sitemap[siteUUID] = check_response.data?.data;

                        yield put(createSiteMapSuccess(sitemap));
                        yield cancel();
                    } 

                } catch (error :any) {
                    if(error.response?.data?.status != 404){
                        const errorMessage = error.response?.data?.message ?? 'error';
                        yield put(createSiteMapError(errorMessage));
                    }
                }
            }
        }
  }

  function* deleteSiteMapSaga({ payload: { siteUUID, pageId } }: PayloadAction<PayloadProps>): SagaIterator {

    try {
        if(!siteUUID ){
            throw new Error("page url not specified");
        }

        const response = yield call(apiInstance.post, `reporttool/organisationlevel/sitemap/urls/delete`, {
                "siteUUID" : siteUUID,
                "isNewVersion": false,
                "urls": [{
                    "id": pageId
                    }]
          });
        if(response.status != 200){
            throw new Error("Faild to delete the url");
        }
        yield put(deleteSiteMapSuccess()); 
    } catch (error: any) {
        const errorMessage = error.response?.data?.message ?? 'error';
        
        yield put(deleteSiteMapError(errorMessage));
    }
}

function* updateSiteMapSaga({ payload: { siteUUID, isNewVersion, urls } }: PayloadAction<PayloadProps>): SagaIterator {

    try {
        if( !siteUUID  ){
            throw new Error("page url not specified");
        }
        const response = yield call(apiInstance.post, 'reporttool/organisationlevel/sitemap/urls/editsitemap', 
            {  
                siteUUID, 
                isNewVersion,
                urls
            }

 
        );
        if(response.status != 200){
            throw new Error("Faild to update the url");
        }       
        yield put(updateSiteMapSuccess(response.data)); 
    } catch (error: any) {
        const errorMessage = error.response?.data?.message ?? 'error';
        yield put(updateSiteMapError(errorMessage));
    }
}


function* reorderSiteMapSaga({ payload: { currentRecordId, targetRecordId } }: PayloadAction<PayloadProps>): SagaIterator {

    try {
        if(!currentRecordId || !targetRecordId  ){
            throw new Error("target records not specified");
        }
        const user = yield select((state) => state.user.data);

        const response = yield call(apiInstance.post, 'reporttool/organisationlevel/sitemap/urls/reorder', 
            {  
                tenantId:user.tenantId,
                currentRecordId,
                targetRecordId
            }
        );
        
        // console.log(response);

        if(response.status != 200){
            throw new Error("Faild to reorder the urls");
        }

        yield put(reorderSiteMapSuccess(response.data.success)); 
    } catch (error: any) {
        const errorMessage = error.response?.data?.message ?? 'error';
        yield put(reorderSiteMapError(errorMessage));
    }
}


function* sitemapUrlsAddSaga({ payload: { siteUUID, isNewVersion=false, versionNumber, urls } }: PayloadAction<PayloadProps>): SagaIterator {

    try {
        if(!siteUUID  ){
            throw new Error("faild to add site");
        }
        const response = yield call(apiInstance.post, 'reporttool/organisationlevel/sitemap/urls/add', 
            {  
                siteUUID,
                isNewVersion,
                versionNumber,
                urls 
            }
        );
        
        if(response.status != 200){
            throw new Error("faild to add site");
        }

        yield put(sitemapUrlsAddSuccess(true)); 
    } catch (error: any) {
        const errorMessage = error.response?.data?.message ?? 'error';
        yield put(sitemapUrlsAddError(errorMessage));
    }
}

function* updateSiteMapFromUrlSaga({ payload: { siteUUID,sitemapURL } }: PayloadAction<PayloadProps>): SagaIterator {   
    try {
        if( !siteUUID || !sitemapURL  ){
            throw new Error("sitemap url or siteUUID not specified");
        }
        const response = yield call(apiInstance.post, 'reporttool/organisationlevel/sitemap/settings/sitemapurl/addorupdate', 
            {  
                siteUUID,
                sitemapURL
            }
        );        
        if(response.status == 200 || response.status == 201 ){
            yield put(updateSiteMapFromUrlSuccess(response.data)); 

            yield put(createSiteMap({ siteUUID }) );
            return;
        }       
        throw new Error("Faild to update from url");
    } catch (error: any) {       
        const errorMessage = error.response?.data?.message ?? 'error';
        yield put(updateSiteMapFromUrlError(errorMessage));
    }
}


function* deleteAllSitemapSaga({ payload: { siteUUID,company_id } }: PayloadAction<PayloadProps>): SagaIterator {   
    try {
        if( !siteUUID || !company_id  ){
            throw new Error("sitemap url or company_id not specified");
        }
        const response = yield call(apiInstance.post, 'reporttool/usermanagement/sitemap/delete-sitemap-records', 
            {  
                siteUUID,
                company_id
            }
        );                
        if(response.status == 200 || response.status == 201 ){
            yield put(DeleteAllSitemapSuccess(response.data?.data)); 
            yield put(fetchSiteMap({ siteUUID }));

            return;
        }       
        throw new Error("Faild to update from url");
    } catch (error: any) {       
        const errorMessage = error.response?.data?.message ?? 'error';
        yield put(DeleteAllSitemapError(errorMessage));
    }
}


function* watchFetchSiteMap() : Generator<StrictEffect, void> {
    yield takeEvery(fetchSiteMap.type, fetchSiteMapSaga);
    yield takeLatest(createSiteMap.type, createSiteMapSaga);
    yield takeLatest(deleteSiteMap.type, deleteSiteMapSaga);
    yield takeLatest(updateSiteMap.type, updateSiteMapSaga);
    yield takeLatest(reorderSiteMap.type, reorderSiteMapSaga);
    yield takeLatest(sitemapUrlsAdd.type, sitemapUrlsAddSaga);
    yield takeLatest(updateSiteMapFromUrl.type, updateSiteMapFromUrlSaga);
    yield takeLatest(DeleteAllSitemap.type, deleteAllSitemapSaga);

}

export { watchFetchSiteMap };
